/**
 * The dashboard's query, shared by every partner page so a link can carry
 * all of it: `org` (which organiser, when one email runs several), `past`
 * (past dates unfolded on the trips page) and `month` (the money page).
 * Switching Trips, Money, Trips lands where she began.
 */
export interface PartnerSearch {
  org?: string;
  past?: 1;
  month?: string;
}

export function parsePartnerSearch(search: Record<string, unknown>): PartnerSearch {
  const out: PartnerSearch = {};
  if (typeof search.org === "string" && /^[0-9a-f-]{36}$/i.test(search.org)) out.org = search.org;
  if (search.past === 1 || search.past === "1" || search.past === true) out.past = 1;
  if (typeof search.month === "string" && /^\d{4}-(0[1-9]|1[0-2])$/.test(search.month)) out.month = search.month;
  return out;
}

/** Every partner link keeps the whole query (CLAUDE.md, state preservation). */
export const keepPartnerSearch = (prev: PartnerSearch): PartnerSearch => prev;
